export default function updateMasqueLigneWithOrdre(lignesCommandes, ordre, masqueLigne) {
  lignesCommandes.forEach((ligne) => {
    let ligneEnfantFind = null;
    if (ligne.lignesCommande) {
      ligneEnfantFind = ligne.lignesCommande.find((ligneEnfant) => {
        return ligneEnfant.ordre === ordre;
      });
    }
    if (ligneEnfantFind) ligneEnfantFind.masqueLigne = masqueLigne;
  });
}
